// The 14 wizard steps (SPEC F7): the text of wsteps.json, extracted from the reference. Light enough for
// Project home (its progress and Next step card read it); the per-style detail is in the lazy
// src/data/logic/wizard.ts.

import wstepsData from './generated/wsteps.json';

export interface WizardStep {
  id: string;
  title: string;
  why: string;
  todo: string[];
  /** [Learn page key, label] pairs from the reference. */
  links: [string, string][];
}

/** The 14 steps in the reference's order. Ids are w01 to w14 and never change (SPEC F7). */
export const WIZARD_STEPS: readonly WizardStep[] = wstepsData.map((w) => ({
  id: w.id,
  title: w.t,
  why: w.why,
  todo: w.todo,
  links: (w.links ?? []) as [string, string][],
}));

export const STEP_COUNT = WIZARD_STEPS.length;

/** The next step: the first unchecked one in order. `undefined` when all are checked. Checks are keyed by step id, so any order works. */
export function nextStep(checks: Readonly<Record<string, boolean>>): WizardStep | undefined {
  return WIZARD_STEPS.find((s) => !checks[s.id]);
}

/** How many of the 14 steps are checked. Keys that are not step ids are ignored. */
export function doneCount(checks: Readonly<Record<string, boolean>>): number {
  return WIZARD_STEPS.filter((s) => checks[s.id]).length;
}

/** "Step N of 14": N is the next unchecked step's place in the list (14 when all are done). */
export function stepNumber(checks: Readonly<Record<string, boolean>>): number {
  const next = nextStep(checks);
  return next ? WIZARD_STEPS.indexOf(next) + 1 : STEP_COUNT;
}
